import { createApp } from "vue"
import { createPinia } from "pinia"
import { createI18n } from "vue-i18n"
import messages from "@intlify/unplugin-vue-i18n/messages"
import { defaultConfig, plugin } from "@formkit/vue"
import { generateClasses } from "@formkit/themes"
import formKitTheme from "./formKitTheme"
import vSelect from "vue-select"
import VueMagnifier from "@websitebeaver/vue-magnifier"
import ClickOutside from "@/directives/click-outside"
import { VueRecaptchaPlugin } from "vue-recaptcha/head"
import App from "./App.vue"
import router from "./router"
import piniaPluginPersistedstate from "pinia-plugin-persistedstate"
import { VueQueryPlugin } from "@tanstack/vue-query"
import { defaultOptionsQueryClient } from "./services/query-client"
import CartItemImage from "./components/cart-page/CartItemImage.vue"

import "@egjs/vue3-flicking/dist/flicking.css"
import "@websitebeaver/vue-magnifier/styles.css"
import "sweetalert2/dist/sweetalert2.min.css"
import "vue-select/dist/vue-select.css"
import "./assets/styles/main.scss"
import "@academy/components/index.css"
import "@vuepic/vue-datepicker/dist/main.css"

import "@/axios"
import { initLinkWords } from "@academy/utils"

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: "en",
  fallbackLocale: "en",
  availableLocales: ["en", "de", "it", "fr"],
  messages: messages,
})

const app = createApp(App).use(
  plugin,
  defaultConfig({
    config: {
      classes: generateClasses(formKitTheme),
    },
  }),
)

const pinia = createPinia()
app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: defaultOptionsQueryClient,
  },
})
pinia.use(piniaPluginPersistedstate)
app.use(pinia)
app.use(router)
app.use(i18n)
app.use(VueMagnifier)
app.use(VueRecaptchaPlugin, {
  v2SiteKey: config.CAPCHA_KEY,
})
app.component("VSelect", vSelect)
app.component('CartItemImage', CartItemImage);

app.directive("click-outside", ClickOutside)

app.mount("#app")

// обработка html для автоподстановки неразделимых пробелок
initLinkWords()
